module.exports = __webpack_public_path__ + "static/ziarul-de-iasi_logo.6bd4739a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners/ziarul-de-iasi_logo.jpg
// module id = 582
// module chunks = 37581630142331